import { MapsAPILoader } from '../agm-compat/maps-api-loader';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';
import { buildErpGmsHandoffAuthUrl } from 'src/utils/portal-auth.util';
import { AutoService } from 'src/services/auto.service';
import { BusinessProfileService } from 'src/services/business-profile.service';
import { DynamicScriptLoaderService } from 'src/services/dynamic-script-loader.service';
import { FileUploadService } from 'src/services/file-upload.service';

declare var jQuery: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  USERSFILESURL: string = environment.USERSFILESURL;
  FILESURL: string = environment.FILESURL;

  /** Workshop signup — ERP register with GMS handoff (same as footer Business Links). */
  readonly erpGmsJoinUrl = buildErpGmsHandoffAuthUrl('register');

  randomQueryParam = `?v=${Math.random().toString(36).substring(7)}`;

  currentUser: any = null;

  latitude: number = -1;
  longitude: number = -1;

  autos: any[] | null = null;

  promotedBusniss: any[] | null = null;

  nearbyBusiness: any[] | null = null;

  nearbyBusinessService: any[] | null = null;

  nearbyBusinessSPare: any[] | null = null;

  nearbyBusinessShowroom: any[] | null = null;

  engineType: any[] = ["Petrol", "Diesel", "Hybrid", "Electric"];

  constructor(private autoService: AutoService, private businessProfileService: BusinessProfileService, private fileUploadService: FileUploadService, private dynamicScriptLoader: DynamicScriptLoaderService, private mapsAPILoader: MapsAPILoader) {
    try {
      const raw = localStorage.getItem('user');
      this.currentUser = raw ? JSON.parse(raw) : null;
    } catch {
      this.currentUser = null;
    }
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.loadPageData();
    } finally {
      this.hidePreloaders();
    }

    setTimeout(() => {
      this.dynamicScriptLoader.load("main");
    }, 0);
  }

  /** `$(window).on('load')` misses if `load` already fired (cache / fast nav); always hide after data. */
  private hidePreloaders(): void {
    try {
      jQuery('.preloader').fadeOut('slow');
    } catch {
      document.querySelectorAll('.preloader').forEach((el) => {
        (el as HTMLElement).style.display = 'none';
      });
    }
  }

  imagesKey: string[] = [];

  pageImages: any = {};

  async loadPageData() {
    let selectedCity = localStorage.getItem('city') ?? "All";

    try {
      this.autos = await this.autoService.getAllAutosAsync(12, -1, -1, selectedCity != "All" ? [{ "key": "city", "value": selectedCity }] : null);

      this.imagesKey = [...this.imagesKey, ...this.autos!.map(a => "usersfiles/" + a.autoid + a.autophotopath1)];
      this.imagesKey = [...this.imagesKey, ...this.autos!.map(a => "appfiles/brandslogo/" + a.makemodeltrim[0].makelogo)];
      this.imagesKey = [...this.imagesKey, ...this.autos!.map(a => "usersfiles/" + a.businessid + a.business[0].businesslogopath)];
    } catch (error) {

    }

    try {
      this.promotedBusniss = await this.businessProfileService.getPromotedBunissProfileAsync(12, this.latitude, this.longitude);

      this.imagesKey = [...this.imagesKey, ...this.promotedBusniss!.map(b => "usersfiles/" + b.businessid + b.businessimagepath1)];
    } catch (error) {

    }

    try {
      this.nearbyBusiness = await this.businessProfileService.getNearbyBunissProfileAsync(12, 25.1576349, 55.2262386);

      this.imagesKey = [...this.imagesKey, ...this.nearbyBusiness!.map(b => "usersfiles/" + b.businessid + b.businessimagepath1)];
    } catch (error) {

    }

    try {
      this.nearbyBusinessService = await this.businessProfileService.getNearbyBunissProfileByTypeAsync(1, 12, this.latitude, this.longitude, selectedCity != "All" ? [{ "key": "location", "value": selectedCity }] : null);

      this.imagesKey = [...this.imagesKey, ...this.nearbyBusinessService!.map(b => "usersfiles/" + b.businessid + b.businessimagepath1)];
    } catch (error) {

    }

    try {
      this.nearbyBusinessSPare = await this.businessProfileService.getNearbyBunissProfileByTypeAsync(2, 12, this.latitude, this.longitude, selectedCity != "All" ? [{ "key": "location", "value": selectedCity }] : null);

      this.imagesKey = [...this.imagesKey, ...this.nearbyBusinessSPare!.map(b => "usersfiles/" + b.businessid + b.businessimagepath1)];
    } catch (error) {

    }

    try {
      this.nearbyBusinessShowroom = await this.businessProfileService.getNearbyBunissProfileByTypeAsync(3, 12, this.latitude, this.longitude, selectedCity != "All" ? [{ "key": "location", "value": selectedCity }] : null);

      this.imagesKey = [...this.imagesKey, ...this.nearbyBusinessShowroom!.map(b => "usersfiles/" + b.businessid + b.businessimagepath1)];
    } catch (error) {

    }


    try {
      this.pageImages = await this.fileUploadService.getBulkPresignedUrls(this.imagesKey);
    } catch (error) {

    }
  }

  async getImageUrl(path: string) {
    var image = null;// await this.fileUploadService.getPresignedUrl("usersfiles/" + path);

    return image;
  }

  getPageName(business: any) {
    let page = "";
    switch (business.businessactivitytype) {
      case 1:
        page = "services";
        break;
      case 2:
        page = "spareparts";
        break;
      case 3:
        page = "showrooms";
        break;
    }

    return page;
  }

  geoToDetails(event: any, services: any) {
    let ctrl = event.target;

    if (ctrl.getAttribute("name") != "location") {
      let page = "";
      switch (services.businessactivitytype) {
        case 1:
          page = "services";
          break;
        case 2:
          page = "spareparts";
          break;
        case 3:
          page = "showrooms";
          break;

      }
      window.location.href = `business/${page}/details/` + services.businessid;
    }
  }

  async getData() {
    let map = await this.mapsAPILoader.load();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position: any) => {
        if (position) {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        } else {
          this.latitude = -1;
          this.longitude = -1;
        }

        await this.loadPageData();
      }, async (error) => {
        this.latitude = -1;
        this.longitude = -1;

        await this.loadPageData();
      })
    }
  }

  async addHits(auto: any) {
    // await this.autoService.addHitsAsync({
    //   "businessid": null,
    //   "autoid": auto.autoid,
    //   "userid": null
    // });

    window.location.href = "auto/details/" + auto.autoid;
  }

}
